/* eslint-disable jira/filename-case */
export const MAX_NOTIFICATION_COUNT = 9;
